export default {
  search: '検索',
  notfound: '絵文字が見つかりません',
  categories: {
    search: '検索結果',
    recent: 'よく使う絵文字',
    smileys: 'スマイリーと感情',
    people: 'スマイリー＆人',
    nature: '動物＆自然',
    foods: 'フード＆ドリンク',
    activity: 'アクティビティ',
    places: 'トラベル＆場所',
    objects: 'オブジェクト',
    symbols: '記号',
    flags: '旗',
    custom: 'カスタム',
  },
  skins: {
    choose: 'デフォルトの肌の色を選択する',
    '1': '標準',
    '2': '明るい肌色',
    '3': 'やや明るい肌色',
    '4': '肌色',
    '5': 'やや濃い肌色',
    '6': '濃い肌色'
  }
}
